import { useFeatureHub, Flags } from "@/common/components/Featurehub";
import { useSelector } from "@/store";


export function useShouldShowReports() {
    const { lvtr } = useSelector((state) => state.user);
    const { context } = useFeatureHub();

    return !!(
        context?.isEnabled(Flags.reports) &&
        lvtr &&
        [
            "lvt_system_administrator",
            "account_administrator",
            "account_administrator_with_sub_clients",
            "partner_with_unit_config",
        ].includes(lvtr)
    );
}
